import React, { useCallback } from 'react';
import { observer } from 'mobx-react';
import { EdgeEditPopover } from '../EdgeEditPopover/EdgeEditPopover';
import { useStore } from '../../../app/data/root.store';
import { CustomEdgeLabel } from './CustomEdge.styles';

export const CustomEdge = observer(({
    id,
    source,
    target,
    sourceX,
    sourceY,
    targetX,
    targetY,
    data
}) => {
    const { entitiesStore, userStore } = useStore();

    const isPopoverOpen = entitiesStore.openPopoverId === id;
    const isTempEdge = id.startsWith('temp-');

    const edgePath = `M${sourceX},${sourceY} C${sourceX},${sourceY + 50} ${targetX},${targetY - 50} ${targetX},${targetY}`;
    const labelX = (sourceX + targetX) / 2;
    const labelY = (sourceY + targetY) / 2;

    const handleLabelClick = useCallback((e) => {
        e.stopPropagation();
        e.preventDefault();

        if (userStore.isActionBlockedByRole('editHoldingEntity') || id === 'ghost-edge' || data?.isGhost || entitiesStore.isCanvasLocked) {
            return;
        }

        entitiesStore?.setOpenPopoverId(id);
    }, [entitiesStore, id, data?.isGhost, userStore]);

    const edgeData = {
        id: isTempEdge ? id : parseInt(id),
        parentBeneficiaryId: parseInt(source),
        childBeneficiaryId: parseInt(target),
        ownershipPercentage: isTempEdge ? '' : (data?.ownership || ''),
        isNewConnection: isTempEdge
    };

    return (
        <>
            <path
                id={id}
                d={edgePath}
                stroke={isPopoverOpen ? '#333' : '#ccc'}
                strokeWidth={1}
                fill="none"
                markerEnd="url(#arrowhead)"
            />
            {(data?.label || isTempEdge) && !data?.isGhost && (
                <foreignObject
                    x={labelX - 40}
                    y={labelY - 20}
                    width={80}
                    height={40}
                    style={{ overflow: 'visible' }}
                >
                    <EdgeEditPopover
                        open={isPopoverOpen || isTempEdge}
                        edge={edgeData}
                    >
                        <CustomEdgeLabel
                            data-edge-label="true"
                            isPopoverOpen={isPopoverOpen}
                            isTempEdge={isTempEdge}
                            onClick={handleLabelClick}
                        >
                            {isTempEdge ? '%' : (data.ownership ? data.ownership : '') + '%'}
                        </CustomEdgeLabel>
                    </EdgeEditPopover>
                </foreignObject>
            )}
        </>
    );
});